import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Badge, FlexBox, Icon, Page, Tabs, } from '@dixa/lib-shared-habla';
import isUndefined from 'lodash/isUndefined';
import pickBy from 'lodash/pickBy';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useMount } from 'react-use';
import { analytics } from 'app/utils/segment';
import { AppLink } from 'components/appLink';
import { currentAgentRoles } from 'components/shared/agentRole';
import { diff } from 'utils/deepObjectDiff';
import { QueuesSettingsForm } from '../../components/queuesSettingsForm';
import { QueuesAgents } from '../../containers/queuesAgents';
import { QueuesAlertsForm } from '../../containers/queuesAlertsForm';
import { QueuesTeams } from '../../containers/queuesTeams';
import { createAlertsPayload, createPayload, EMPTY_CHANNEL_TIMEOUT, } from '../utils';
export const QueuesDetailsPage = (props) => {
    const navigate = useNavigate();
    const params = useParams();
    useMount(() => {
        const { id } = params;
        if (id) {
            props.queues.getQueue(id);
        }
    });
    const isEditMode = props.mode === 'edit';
    const initFormValues = () => {
        const { queues } = props;
        const { item } = queues;
        if (!item) {
            return {
                name: '',
                priority: null,
                is_default: false,
                is_archived: false,
                offer_timeout: null,
                wrapup_timeout: null,
                offer_algorithm: 'one_at_a_time_random',
                is_do_not_offer_enabled: false,
                do_not_offer_timeouts: EMPTY_CHANNEL_TIMEOUT,
                offer_abandoned_conversations: false,
                is_preferred_agent_enabled: false,
                is_personal_offer_prioritized: false,
                preferred_agent_timeouts: EMPTY_CHANNEL_TIMEOUT,
                preferred_agent_offline_timeout_enabled: false,
                preferred_agent_offline_timeout: 0,
                personal_agent_offline_timeout_enabled: false,
                personal_agent_offline_timeout: 0,
            };
        }
        return Object.assign(Object.assign({}, item), { do_not_offer_timeouts: item.do_not_offer_timeouts || EMPTY_CHANNEL_TIMEOUT, offer_abandoned_conversations: item.offer_abandoned_conversations, preferred_agent_timeouts: item.preferred_agent_timeouts || EMPTY_CHANNEL_TIMEOUT, preferred_agent_offline_timeout_enabled: item.preferred_agent_offline_timeout !== null, preferred_agent_offline_timeout: item.preferred_agent_offline_timeout || 0, personal_agent_offline_timeout_enabled: item.personal_agent_offline_timeout !== null, personal_agent_offline_timeout: item.personal_agent_offline_timeout || 0 });
    };
    const handleQueueSettingsAnalytics = (values) => {
        const { do_not_offer_timeouts: lastAgentWaitingTime, is_default: isDefault, is_archived: isArchived, is_do_not_offer_enabled: lastAgentActive, is_personal_offer_prioritized: isPersonalOfferPrioritized, is_preferred_agent_enabled: preferredAgentActive, offer_algorithm: offerAlgorithm, offer_abandoned_conversations: offerAbandonedConversation, offer_timeout: offerTimeout, personal_agent_offline_timeout_enabled: lastAgentOffline, preferred_agent_timeouts: preferredAgentWaitingTime, preferred_agent_offline_timeout_enabled: preferredAgentOffline, priority: priorityLevel, wrapup_timeout: wrapUpTimeout, } = diff(isEditMode ? initFormValues() : {}, values);
        (isEditMode ? analytics.settingsQueueSaved : analytics.settingsQueueAdded)(pickBy({
            // General
            priorityLevel,
            isDefault,
            isArchived,
            // Offer settings
            offerAlgorithm,
            offerTimeout,
            wrapUpTimeout,
            offerAbandonedConversation,
            // Last Agent
            lastAgentActive,
            isPersonalOfferPrioritized,
            lastAgentWaitingTimePhone: lastAgentWaitingTime === null || lastAgentWaitingTime === void 0 ? void 0 : lastAgentWaitingTime.pstn_phone,
            lastAgentWaitingTimeEmail: lastAgentWaitingTime === null || lastAgentWaitingTime === void 0 ? void 0 : lastAgentWaitingTime.email,
            lastAgentWaitingTimeChat: lastAgentWaitingTime === null || lastAgentWaitingTime === void 0 ? void 0 : lastAgentWaitingTime.widget_chat,
            lastAgentWaitingTimeTexts: lastAgentWaitingTime === null || lastAgentWaitingTime === void 0 ? void 0 : lastAgentWaitingTime.facebook_messenger,
            lastAgentOffline,
            // Preferred Agent
            preferredAgentActive,
            preferredAgentWaitingTimePhone: preferredAgentWaitingTime === null || preferredAgentWaitingTime === void 0 ? void 0 : preferredAgentWaitingTime.pstn_phone,
            preferredAgentWaitingTimeEmail: preferredAgentWaitingTime === null || preferredAgentWaitingTime === void 0 ? void 0 : preferredAgentWaitingTime.email,
            preferredAgentWaitingTimeChat: preferredAgentWaitingTime === null || preferredAgentWaitingTime === void 0 ? void 0 : preferredAgentWaitingTime.widget_chat,
            preferredAgentWaitingTimeTexts: preferredAgentWaitingTime === null || preferredAgentWaitingTime === void 0 ? void 0 : preferredAgentWaitingTime.facebook_messenger,
            preferredAgentOffline,
        }, (type) => !isUndefined(type)));
    };
    const handleQueuesSettingsFormSubmit = (values) => {
        const { notificationAdd, queues } = props;
        const { createQueue, updateQueue, item, getQueue } = queues;
        (isEditMode && item
            ? updateQueue(item.id, createPayload(values, item))
            : createQueue(createPayload(values)))
            .then((r) => {
            notificationAdd({
                title: `Queue ${isEditMode ? 'updated' : 'created'}`,
                text: `Queue "${values.name}" ${isEditMode ? 'updated' : 'created'}`,
                className: 'success',
                time: 5000,
                icon: 'i-done',
            });
            handleQueueSettingsAnalytics(values);
            navigate(`/settings/queues/${r.data.id}`);
            getQueue(r.data.id);
        })
            .catch((e) => {
            console.error('createQueue exception:', e);
            notificationAdd({
                title: 'An error occurred',
                text: `An error occurred when trying to ${isEditMode ? 'update' : 'create'} the "${values.name}" queue`,
                icon: 'i-exclamation',
                className: 'danger',
            });
        });
    };
    const initAlertsFormValues = () => {
        var _a, _b;
        const { queues } = props;
        const { item } = queues;
        if (item && item.queue_thresholds) {
            return {
                is_sla_percentage: !!item.queue_thresholds.sla_percentage,
                sla_percentage: item.queue_thresholds.sla_percentage || 80,
                sla_time_limit: item.queue_thresholds.sla_time_limit,
                is_longest_wait: !!((_a = item.queue_thresholds) === null || _a === void 0 ? void 0 : _a.longest_wait),
                longest_wait: item.queue_thresholds.longest_wait || 20,
                is_available_agents: !!item.queue_thresholds.available_agents,
                available_agents: item.queue_thresholds.available_agents,
                is_waiting_conversations: !!item.queue_thresholds.waiting_conversations,
                waiting_conversations: ((_b = item.queue_thresholds) === null || _b === void 0 ? void 0 : _b.waiting_conversations) || 10,
            };
        }
        return {
            is_sla_percentage: false,
            sla_percentage: 0,
            sla_time_limit: 20,
            is_longest_wait: false,
            longest_wait: 0,
            is_available_agents: false,
            available_agents: 0,
            is_waiting_conversations: false,
            waiting_conversations: 0,
        };
    };
    const handleQueueAlertsAnalytics = (values) => {
        const { is_sla_percentage: serviceLevelAlertEnabled, sla_percentage: serviceLevelPercentage, sla_time_limit: serviceLevelTimeLimit, is_longest_wait: currentLongestWaitEnabled, longest_wait: currentLongestWait, is_available_agents: availableAgentsEnabled, available_agents: availableAgentsLimit, is_waiting_conversations: maximumWaitingEnabled, waiting_conversations: maximumWaiting, } = diff(initAlertsFormValues(), values);
        analytics.settingsQueueAlertsSaved(pickBy({
            serviceLevelAlertEnabled,
            serviceLevelPercentage,
            serviceLevelTimeLimit,
            currentLongestWaitEnabled,
            currentLongestWait,
            availableAgentsEnabled,
            availableAgentsLimit,
            maximumWaitingEnabled,
            maximumWaiting,
        }, (type) => !isUndefined(type)));
    };
    const handleQueuesAlertsFormSubmit = (values) => {
        const { notificationAdd, queues } = props;
        const { updateQueue, item, getQueue } = queues;
        if (item) {
            updateQueue(item.id, createAlertsPayload(values, item))
                .then((r) => {
                notificationAdd({
                    title: 'Queue updated',
                    text: `Queue "${item.name}" updated`,
                    className: 'success',
                    time: 5000,
                    icon: 'i-done',
                });
                handleQueueAlertsAnalytics(values);
                getQueue(r.data.id);
            })
                .catch((e) => {
                console.error('createQueue exception:', e);
                notificationAdd({
                    title: 'An error occurred',
                    text: `An error occurred when trying to update the "${item.name}" queue`,
                    icon: 'i-exclamation',
                    className: 'danger',
                });
            });
        }
    };
    const { queues, hasTeamsFeatureFlag, agent } = props;
    const { id: queueId } = params;
    const { item: queue, createAsyncStatus, updateAsyncStatus } = queues;
    const { at_least_systemadmin } = currentAgentRoles(agent);
    const tabsDefinition = [];
    if (at_least_systemadmin) {
        tabsDefinition.push({
            id: 'queueSettings',
            label: 'Queue settings',
        });
        tabsDefinition.push({
            id: 'alertsTab',
            label: 'Alerts',
            disabled: !isEditMode,
        });
    }
    tabsDefinition.push({
        id: 'agentsTab',
        label: 'Agents',
        disabled: !isEditMode,
    });
    if (hasTeamsFeatureFlag) {
        tabsDefinition.push({
            id: 'teamsTab',
            label: 'Teams',
            disabled: !isEditMode,
        });
    }
    const [activeTab, setActiveTab] = useState(tabsDefinition[0].id);
    return (_jsxs(Page, { children: [_jsx(Page.Head, { title: _jsxs(FlexBox, Object.assign({ gap: "200", alignItems: "center" }, { children: [_jsx(AppLink, Object.assign({ path: "/settings/queues", style: { color: 'inherit' } }, { children: "Queues" })), _jsx(Icon, { name: "angle-right" }), queue ? queue.name : 'Create queue', (queue === null || queue === void 0 ? void 0 : queue.is_archived) && (_jsx(Badge, Object.assign({ variant: "error", size: "medium" }, { children: "Archived" })))] })) }), _jsx(Page.Tabs, { children: _jsx(Tabs, { selectedId: activeTab, tabs: tabsDefinition, onChange: (tab) => setActiveTab(tab) }) }), _jsxs(Page.Body, { children: [activeTab == 'queueSettings' && at_least_systemadmin && (_jsx(QueuesSettingsForm, { onSubmit: handleQueuesSettingsFormSubmit, mode: isEditMode ? 'edit' : 'create', initialValues: initFormValues(), isLoading: createAsyncStatus === 'loading' || updateAsyncStatus === 'loading' })), activeTab === 'alertsTab' && at_least_systemadmin && (_jsx(QueuesAlertsForm, { onSubmit: handleQueuesAlertsFormSubmit, initialValues: initAlertsFormValues(), isLoading: createAsyncStatus === 'loading' || updateAsyncStatus === 'loading' })), activeTab === 'agentsTab' && (_jsx(_Fragment, { children: queue !== null && queueId && (_jsx(QueuesAgents, { queueId: queueId, queueOfferAlgorithm: queue.offer_algorithm, queueName: queue.name })) })), activeTab === 'teamsTab' && (_jsx(_Fragment, { children: hasTeamsFeatureFlag && queue !== null && queueId && (_jsx(QueuesTeams, { queueId: queueId, queueOfferAlgorithm: queue.offer_algorithm, queueName: queue.name })) }))] })] }));
};
